import { LocalTips } from '@/components/logistics/LocalTips';

export function CombinedLocalTips() {
  return (
    <div className="space-y-6">
      <LocalTips />
    </div>
  );
}